/**
 * TabActionMenu — dropdown menu for custom tab actions.
 * Owners see: Edit, Hide, Duplicate, View filters.
 * Non-owners see: Hide, Duplicate, View filters.
 */

import React from 'react';
import { Dropdown, MenuProps } from 'antd';
import { MapSettingsIcon } from '@/assets/icons/icons';
import { useTranslation } from 'react-i18next';

interface Props {
  isOwner: boolean;
  onEdit: () => void;
  onHide: () => void;
  onDuplicate: () => void;
  onViewFilters: () => void;
}

const TabActionMenu: React.FC<Props> = ({
  isOwner,
  onEdit,
  onHide,
  onDuplicate,
  onViewFilters,
}) => {
  const { t } = useTranslation('shipments');

  const items: MenuProps['items'] = [
    ...(isOwner
      ? [
          {
            key: 'edit',
            label: t('tabs.tabActions.edit'),
            onClick: onEdit,
          },
        ]
      : []),
    {
      key: 'hide',
      label: t('tabs.tabActions.hide'),
      onClick: onHide,
    },
    {
      key: 'duplicate',
      label: t('tabs.tabActions.duplicate'),
      onClick: onDuplicate,
    },
    {
      key: 'view_filters',
      label: t('tabs.tabActions.viewFilters', 'View filters'),
      onClick: onViewFilters,
    },
  ];

  return (
    <Dropdown menu={{ items }} trigger={['click']} placement='bottomRight'>
      <span onClick={(e) => e.stopPropagation()}>
        <MapSettingsIcon />
      </span>
    </Dropdown>
  );
};

export default TabActionMenu;
